import apiService from './api';
import type { ApiResponse } from '../types/api';
import type {
  SatelliteFarm,
  SatelliteImages,
  SatelliteRefresh,
  SatelliteSceneStats,
  SatelliteSeries,
  SatelliteTargetType,
} from '../types/satellite';

// Switching on and "Check for new images" fetch passes from Earth Search inside
// the request, which can take most of a minute.
const FETCH_TIMEOUT = { timeout: 90_000 };

class SatelliteService {
  async getFarm(farmId: number): Promise<ApiResponse<SatelliteFarm>> {
    return apiService.get(`/orchard/satellite/farms/${farmId}`);
  }

  async setEnabled(farmId: number, enabled: boolean): Promise<ApiResponse<SatelliteFarm>> {
    return apiService.put(`/orchard/satellite/farms/${farmId}`, { enabled }, undefined, FETCH_TIMEOUT);
  }

  async refresh(farmId: number): Promise<ApiResponse<SatelliteRefresh>> {
    return apiService.post(`/orchard/satellite/farms/${farmId}/refresh`, {}, undefined, FETCH_TIMEOUT);
  }

  async getImages(sceneId: number): Promise<ApiResponse<SatelliteImages>> {
    return apiService.get(`/orchard/satellite/scenes/${sceneId}/images`);
  }

  async getSceneStats(sceneId: number): Promise<ApiResponse<SatelliteSceneStats>> {
    return apiService.get(`/orchard/satellite/scenes/${sceneId}/stats`);
  }

  async getSeries(type: SatelliteTargetType, id: number): Promise<ApiResponse<SatelliteSeries>> {
    return apiService.get(`/orchard/satellite/series/${type}/${id}`);
  }
}

export default new SatelliteService();
